import React, { useEffect, useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap';
import { getData } from '../actions/dataActions'
import { useSelector, useDispatch } from 'react-redux'
import { toggleLoaded } from '../reducers/LoadedSlice'
import { setDataState } from '../reducers/DataSlice'
import MainScreen from '../components/MainScreen'
import Table from '../components/Table'
import Tablee from '../components/Tablee'
import Header from '../components/Header'
import MapWidget from '../components/MapWidget'
import { toggleDraw } from '../reducers/DrawSlice';
import { toggleMenuOpen } from '../reducers/MenuOpenSlice'
import { setItem } from "../reducers/ItemSlice";
import MultiSelectDropdown from "../components/MultiSelectDropdown"
import { GridLoader, PropagateLoader } from "react-spinners";
import './HomePage.css'

const HomePage = () => {
    const sources = useSelector((state) => state.sources.value)
    const loaded = useSelector((state) => state.loaded.value)
    const colors = useSelector((state) => state.colors.value)
    const mapReady = useSelector((state) => state.mapReady.value)
    const data = useSelector((state) => state.data.value)
    const param = useSelector((state) => state.param.value)
    const dispatch = useDispatch()
    const [style, setStyle] = useState({
        zIndex: -1
    })

    useEffect(() => {
        if (mapReady) {
           setStyle({
                zIndex: 99
            })
            console.log("test")
            
        }

    }, [mapReady])

    const handleRightClick = (e) => {
        e.preventDefault()
        
        // const hotels = data[0][param].map(d => d.name)
        // const idxs = data[0][param].map(d => d.idx)
        
        dispatch(setItem({
            type: "hotel", 
            names:[],
            data: [],
            idxs:[]
        }))
    };

    const handleLeftClick = (e) => {
        e.preventDefault()
        dispatch(toggleMenuOpen(false))
    };

    useEffect(() => {
        if (!loaded) {
            sources.forEach((source, idx) => {
                dispatch(getData(source, idx))
            })
            dispatch(toggleLoaded(true))
        }
    }, [loaded, dispatch, sources]);


    return (

        <>

            < Container id="app-container" fluid onContextMenu={handleRightClick}
            >
                <Row className={"map-container p-0 m-0" }>                 
                    <>
                        <Col md={5} id="map-col" >
                            <MapWidget />
                        </Col>
                        <Col md={7} align="center" id="side-panel"  >
                            <Header />
                            <MultiSelectDropdown />
                            <Table />
                        </Col>
                    </>
             

                </Row>
            </Container>


        </>
    )
}
export default HomePage
